import * as actionType from '../actionTypes';

const initialState = {
    createAppData: ''
}
const createapp = (state = initialState, action) => {
    switch (action.type) {
        case actionType.CREATEAPP:
            return {
                ...state,
                createAppData: action.data
            };
        case actionType.CREATEAPP_CLEAR:
            return {};
        default:
            return state
    }
}
export default createapp;